import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { USER_DETAILS_QUERY_KEY } from '../sharedQueries';
import { isConnectFinancialCustodyUser } from '../custodyProvider';

const useIsConnectFinancialCustodyUser = () => {
  const { data: userData } = useQuery(USER_DETAILS_QUERY_KEY);

  return useMemo(() => isConnectFinancialCustodyUser(userData?.user), [userData]);
};

export default useIsConnectFinancialCustodyUser;
